import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";

//components
import {
  Curve,
  NewBackButton,
  RightArrowNew,
  MarkIcon,
  SearchIcon,
  DoneIconNew,
} from "../svgs";
import { CurveHolder, StyledText, Button } from "./basic";

const AlertModal = ({
  background,
  success,
  message,
  onClick = () => {},
  children,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        left: 0,
        top: 0,
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <AlertCurveTop />
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "70%",
          top: "22%",
          padding: "10px",
          textAlign: "center",
          boxSizing: "border-box",
        }}
      >
        <AlertIconContainer>
          <div style={{ width: "68px", height: "68px", borderRadius: "50px" }}>
            {success ? (
              <DoneIconNew fill={"#fff"} />
            ) : (
              <div
                style={{
                  color: background,
                  background: "#fff",
                  width: "68px",
                  height: "68px",
                  fontSize: "3em",
                  display: "flex",
                  justifyContent: "center",
                  fontFamily: "MTNBold",
                  alignItems: "center",
                  borderRadius: "50px",
                }}
              >
                <span>!</span>
              </div>
            )}
          </div>
        </AlertIconContainer>

        {children ? (
          children
        ) : (
          <>
            <h1
              style={{
                fontFamily: "MTNBold",
                fontSize: "1.5em",
                marginTop: "40px",
                marginBottom: "50px",
              }}
            >
              {success ? "Congrats!" : "Sorry!"}
            </h1>
            <p style={{ fontFamily: "MTNRegular" }}>
              {message || "Offer code has been successfully redeemed!"}
            </p>
            <ButtonHolder>
              <Button
                onClick={() => onClick()}
                style={{
                  marginInline: 20,
                  marginBlock: 20,
                  height: "40px",
                  width: "40%",
                  justifyContent: "center",
                  alignItems: "center",
                  alignSelf: "center",
                  display: "flex",
                  cursor: "pointer",
                }}
                color={background}
              >
                <StyledText color={"white"}>
                  {success ? "Great!" : "OK"}
                </StyledText>
              </Button>
            </ButtonHolder>
          </>
        )}
      </div>
    </div>
  );
};

const AlertCurveTop = styled.div`
  position: absolute;
  width: 100%;
  height: 70%;
  top: 30%;
  backgroundcolor: "#fff";
  border-top-left-radius: 20px;
  background-color: rgb(255, 255, 255);
  border-top-right-radius: 20px;
`;

const AlertIconContainer = styled.div`
  margin: 0px auto;
  background-color: rgb(245, 130, 30);
  height: 100px;
  width: 100px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
`;
const ButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export default AlertModal;
